import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// import { createSystem, defaultConfig } from "@chakra-ui/react";

import { Provider } from "react-redux";
import { store } from "./store";
import "./lib/DurationPicker/DurationPicker.scss";
import "./interceptor";
import "react-phone-input-2/lib/style.css";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Toaster2 } from "react-hot-toast";

import { Provider as ChakraProvider } from "./components/ui/provider";
import { AuthProvider } from "./contexts/AuthContext";
import { ConfigProvider } from "./providers/authProvider";
import { ConfirmModalProvider } from "./providers/confirmModalProvider";
import dayjs from "dayjs";
import "dayjs/locale/it"; // importa la lingua italiana
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./constants/queryClient";
import { InfoDrawerProvider } from "./providers/InfoDrawer";
import { TransitionProvider } from "./providers/TransitionProvider";
import { ThemeProvider } from "./providers/ThemeContext";

dayjs.locale("it");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ChakraProvider>
        <ThemeProvider>
          <AuthProvider>
            <ConfirmModalProvider>
              <InfoDrawerProvider>
                <ConfigProvider>
                  <BrowserRouter>
                    <TransitionProvider>
                      <App />
                    </TransitionProvider>
                  </BrowserRouter>
                </ConfigProvider>
              </InfoDrawerProvider>
            </ConfirmModalProvider>
          </AuthProvider>
        </ThemeProvider>
        <Toaster />
        <Toaster2
          position="top-center"
          containerStyle={{
            // z-index custom > 9999 default (che e' position:fixed full-
            // viewport e crea uno stacking context sopra le modal Chakra
            // Dialog z=1400 → bug "modal va sotto pagina" su programmazione
            // campo). 11000 supera 9999 ma resta sotto le modal Chakra
            // boost-ate via CSS in index.scss (12000+).
            zIndex: 11000,
          }}
          toastOptions={{
            duration: 4000,
          }}
        />
      </ChakraProvider>
    </Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
